import { HOME_PATH } from '../../constants'
import serverData from '../server-data'

export const goToCIP = () => {
  // docs: https://paypal.atlassian.net/wiki/spaces/P2PConsumer/pages/824360735/High+Level+Solution+-+PP+Groups+Product+Provisioning+-+Draft

  const productID = 'groups'
  const flowIntent = 'GROUPS'
  const flowEntryPoint = 'p2p'
  const successUrl = `${HOME_PATH}/create`
  const returnUrl = `${HOME_PATH}`

  window.location.assign(
    `${
      serverData?.urls?.cip || ''
    }/myaccount/info/flow/provision/${productID}?entryPoint=${flowEntryPoint}&intent=${flowIntent}&successUrl=${successUrl}&returnUrl=${returnUrl}`,
  )
}
